import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import {PermissionService} from "../../core/authorization/permission.service";

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivateChild {
  constructor(private permissionService: PermissionService, private router: Router) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredPermission = childRoute.data['permissions'];
    if (!requiredPermission) return true;

    if (this.permissionService.hasPermission(requiredPermission)) {
      return true;
    }
    return this.router.createUrlTree(['/authentication/access-denied']);
  }
}
